// src/pages/Home.js
import React, { useEffect, useState } from "react";
import ProductCard from "../../components/ProductCard/ProductCard";
import {fetchProducts} from "../../services/api";

export default function Home() {
    const [products, setProducts] = useState([]);
    useEffect(() => {
        fetchProducts()
            .then(res => setProducts(res.data))
            .catch(console.error);
    }, []);

    return (
        <div className="max-w-7xl mx-auto mt-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                {products.map(product => (
                    <ProductCard key={product.id} product={product} />
                ))}
            </div>
        </div>
    );
}
